module.exports = __webpack_public_path__ + "img/home-shortcuts-inner.648b403f.png";